import { useToast } from '@entur/alert'
import { useApi } from '../api-clients/client-hooks'
import { AcceptDraftResponse, Fetch } from '../api-clients/api-types'
import { useEmployee } from '../contexts/employee-context'
import { postAcceptDraft, postRejectDraft } from '../api-clients/eba-clients'
import { useFamilyMembers } from '../contexts/family-members-context'
import { trackEvent } from '../utils/tracking-utils'

type Config = {
  onSuccess?: () => void
}
export const useAcceptDraft = (config?: Config): [Fetch<AcceptDraftResponse>, () => void] => {
  const { addToast } = useToast()
  const { employee, setEmployee } = useEmployee()
  const { setFamilyMembers } = useFamilyMembers()

  const [acceptDraftResponse, post] = useApi(postAcceptDraft, {
    successCallback: (data) => {
      setEmployee({
        ...data.nonSensitiveEmployeeDataResponse,
        draftEmployee: undefined,
        sensitiveInfo: { ...data.sensitiveEmployeeDataResponse },
      })
      setFamilyMembers(data.familyMemberResponse)

      trackEvent('Accept-Draft', { category: 'Draft' })
      addToast({
        content: 'Utkast er godkjent',
      })
      if (config?.onSuccess) {
        config?.onSuccess()
      }
    },
  })

  const acceptDraft = () => {
    post({
      id: employee.id,
    })
  }

  return [acceptDraftResponse, acceptDraft]
}

export const useRejectDraft = (): [Fetch<unknown>, () => void] => {
  const { addToast } = useToast()
  const { employee, setEmployee, setSensitiveInfo } = useEmployee()
  const { setDraftTicketRights, familyMembersResponse } = useFamilyMembers()

  const [rejectDraftResponse, post] = useApi(postRejectDraft, {
    successCallback: () => {
      setEmployee({
        ...employee,
        draftEmployee: undefined,
      })
      if (employee.sensitiveInfo)
        setSensitiveInfo({
          ...employee.sensitiveInfo,
          draftEmployee: undefined,
        })

      if (familyMembersResponse) setDraftTicketRights([])
      trackEvent('Reject-Draft', { category: 'Draft' })
      addToast({
        content: 'Utkastet ble slettet!',
      })
    },
  })

  const rejectDraft = () => {
    post({ id: employee.id })
  }
  return [rejectDraftResponse, rejectDraft]
}
